import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import { Card, Typography } from "material-ui";
import NotificationScroll from "../components/NotificationScroll";
import { fetchNotifications } from "../actions/notifications.actions";
import { grey } from "material-ui/colors/index";

const styleSheet = theme => ({
    container: {
        margin: `${theme.spacing.unit * 2}px auto`,
        maxWidth: 540,
        width: "100%",
        alignItems: "vertical",
        justifyContent: "left"
    },
    cardContainer: {
        padding: theme.spacing.unit
    },
    title: {
        margin: `${2 * theme.spacing.unit}px 0 ${2 * theme.spacing.unit}px ${3 *
            theme.spacing.unit}px`,
        fontWeight: 300,
        color: grey[700]
    }
});

class NotificationsPage extends Component {
    static propTypes = {
        pagedRequest: PropTypes.object.isRequired,
        classes: PropTypes.object,
        dispatch: PropTypes.func.isRequired
    };

    loadMore = () => {
        const {
            pagedRequest: { pageInfo: { endCursor } },
            dispatch
        } = this.props;
        dispatch(
            fetchNotifications({ replace: true, first: 10, after: endCursor })
        );
    };

    renderNotifications() {
        const {
            pagedRequest: { edges, pageInfo: { hasNextPage } }
        } = this.props;

        return (
            <NotificationScroll
                edges={edges}
                hasMore={hasNextPage}
                loadMore={this.loadMore}
            />
        );
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div className={classes.container}>
                <Typography
                    className={classes.title}
                    component="h3"
                    type="body1">
                    {t("notificationsPage.Notifications")}
                </Typography>
                <Card elevation={1} className={classes.cardContainer}>
                    {this.renderNotifications()}
                </Card>
            </div>
        );
    }
}

function mapStateToProps({
    notifications: { notificationsPagedRequest: pagedRequest }
}) {
    return {
        pagedRequest
    };
}

export default wrapComponent(NotificationsPage, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage.jsx